const cards = [
  {
    title: '某选秀冠军深夜发文暗示退圈，粉丝集体破防',
    summary: '三年前凭借选秀节目一炮而红，如今却在社交平台发布长文，字里行间透露出退圈意向，评论区瞬间炸锅。',
    tag: '娱乐圈',
    time: '2小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20a%20spotlight%20stage%20with%20a%20single%20microphone%20stand%20in%20warm%20coral%20and%20amber%20lighting%2C%20dramatic%20theatrical%20atmosphere%2C%20artistic%20magazine%20style%2C%20dark%20background%20with%20soft%20glow%2C%20emotional%20and%20melancholic%20mood%2C%20no%20text%20no%20letters&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    title: '两大视频平台争夺独家版权，背后博弈引热议',
    summary: '某爆款综艺续集引发平台抢购大战，最终成交价据传突破行业纪录。业内人士分析这背后是流媒体格局的深刻变局。',
    tag: '行业动态',
    time: '5小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20illustration%20of%20two%20competing%20digital%20screens%20facing%20each%20other%20in%20abstract%20space%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20corporate%20rivalry%20concept%2C%20editorial%20design%20style%2C%20dramatic%20lighting%20on%20dark%20background%2C%20no%20text%20no%20letters&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    title: '知名导演新片选角争议，原著作者发声表态',
    summary: '备受期待的IP改编电影公布演员阵容后引发巨大争议，原著作者在社交平台发长文表达不满，制片方暂未回应。',
    tag: '影视圈',
    time: '8小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20artistic%20illustration%20of%20a%20film%20clapperboard%20and%20script%20pages%20floating%20in%20dramatic%20lighting%2C%20warm%20coral%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20editorial%20magazine%20aesthetic%2C%20dark%20background%20with%20soft%20spotlight%20effects%2C%20no%20text%20no%20letters&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    title: '短视频平台网红收入排行榜流出，第一名年入过亿',
    summary: '一份据称来自MCN机构内部的收入榜单在社交平台疯传，多位头部网红的真实收入数据令人咋舌，引发关于行业泡沫的讨论。',
    tag: '网红经济',
    time: '12小时前',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20modern%20illustration%20of%20floating%20golden%20coins%20and%20digital%20screens%20with%20upward%20trending%20arrows%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20wealth%20and%20social%20media%20concept%2C%20editorial%20design%20aesthetic%2C%20dark%20background%20with%20soft%20glow%2C%20no%20text%20no%20letters&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    title: '某品牌发布会现场事故，代言人反应引全网点赞',
    summary: '在一场大型品牌发布会上，舞台设备突发故障，代言人临危不乱的处理方式赢得现场掌声和全网好评。',
    tag: '社会热点',
    time: '1天前',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20stylized%20editorial%20illustration%20of%20a%20dramatic%20stage%20moment%20with%20spotlight%20and%20scattered%20light%20particles%2C%20warm%20coral%20and%20amber%20lighting%2C%20suspenseful%20atmosphere%2C%20artistic%20magazine%20collage%20style%2C%20dark%20background%2C%20no%20text%20no%20letters&width=600&height=400&seq=card-05&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            爆料精选
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            编辑精选近期最值得围观的吃瓜资讯
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 3).map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-all cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {cards.slice(3, 5).map((item, idx) => (
            <div
              key={idx + 3}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-accent-300/50 transition-all cursor-pointer flex flex-col sm:flex-row"
            >
              <div className="sm:w-48 flex-shrink-0 aspect-[3/2] sm:aspect-auto overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col justify-center">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs font-medium text-primary-600 bg-primary-100 px-2 py-0.5 rounded-full">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.summary}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}